module.exports = __webpack_public_path__ + "img/ctr.edc75291.svg";